import { render, staticRenderFns } from "./OriginalData.vue?vue&type=template&id=020b18f8&"
import script from "./OriginalData.vue?vue&type=script&lang=ts&"
export * from "./OriginalData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports